<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'App',
  beforeMount() {
    const $ratio = $('#ratio')
    const w = $ratio.width()
    const bw = $('body').width()
    console.error(`[beforeMount]1cm 像素大小: ${w}`)
    this.$store.dispatch('redraw/updateA4SizeRatio', { w, bw })
  }
}  
</script>
<style lang="scss">
@import '@/styles/com';
@import '@/styles/mixin';
@import '@/styles/variables';
$tmpc: #f6f6f6;
/* $tmpc: red; */
html,
body {
  margin: 0;
  background-color: $tmpc;
}
body {
    /* @include flexRow(space-around, flex-start); */
}
#app {
    /* width: $sizeWidth; */
    @include bBox;
    /* width: 29.7cm; */
    /* width: 98%; */
    margin: 0 auto;
    background-color: $tmpc;
    /* margin: 12px; */
    /* padding: 30px 0; */
}
</style>
